import React from "react";
import Typography from "@material-ui/core/Typography";

import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import PleaseExplain from "../../common/PleaseExplain";
import TextareaWithCharCount from "../../common/TextareaWithCharCount";
import YesNoField from "../../common/YesNoField";
import YesNoNAField from "../../common/YesNoNAField";

const PastPerformanceFields = () => {
  return (
    <FormStep>
      <FormSection title="I. Past Performance">
        <YesNoField
          label="1. Do you have the ability to complete certified payrolls?"
          name="capableCertifiedPayrolls"
        />

        <Typography variant="h5">
          Within the prior three years, has your firm:
        </Typography>

        <YesNoField
          label="2. Ever received a Show of Cause, negative CPAR, or Cure Notice?"
          name="receivedShowOfCauseEtc"
        />
        <PleaseExplain name="receivedShowOfCauseEtc">
          <TextareaWithCharCount
            label="Please explain."
            name="receivedShowOfCauseEtcExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>

        <YesNoField
          label="3. Ever received a Notice of Default?"
          name="receivedNoticeOfDefault"
        />
        <PleaseExplain name="receivedNoticeOfDefault">
          <TextareaWithCharCount
            label="Please explain"
            name="receivedNoticeOfDefaultExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>

        <YesNoField
          label="4. Ever been in bankruptcy, voluntary or involuntary reorganization?"
          name="everBankrupt"
        />
        <PleaseExplain name="everBankrupt">
          <TextareaWithCharCount
            label="Please explain"
            name="everBankruptExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>

        <YesNoField
          label="5. Ever been disbarred from pursuing public work?"
          name="everDisbarred"
        />
        <PleaseExplain name="everDisbarred">
          <TextareaWithCharCount
            label="Please explain"
            name="everDisbarredExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>

        <YesNoField
          label="6. Ever been fined by any regulatory agency for non-compliance? (Including OSHA, DOL, DOT, EPA, DEC, etc.)"
          name="everFined"
        />
        <PleaseExplain name="everFined">
          <TextareaWithCharCount
            label="Please explain"
            name="everFinedExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>

        <YesNoNAField
          label={
            <span>
              7. Have any outstanding/unresolved financial/audit issues with{" "}
              <abbr title="Defense Contract Audit Agency">DCAA</abbr>?
            </span>
          }
          name="issuesWithDCAA"
        />
        <PleaseExplain name="issuesWithDCAA">
          <TextareaWithCharCount
            label="Please explain"
            name="issuesWithDCAAExplanation"
            required
            maxCharInput={500}
          />
        </PleaseExplain>
      </FormSection>
    </FormStep>
  );
};

export default PastPerformanceFields;
